class ProductVideoFloat extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector('[data-video-toggle]');
    this.closeBtn = this.querySelector('[data-video-close]');
    this.panel = this.querySelector('.product-video-float__panel');
    this.video = this.querySelector('.product-video-float__video');
    this.miniVideo = this.querySelector('.product-video-float__mini-video');
  }

  connectedCallback() {
    this.toggleBtn?.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.miniVideo?.play().catch(() => {});
  }

  open() {
    if (!this.panel) return;
    this.panel.hidden = false;
    this.classList.add('is-open');
    if (this.video) {
      this.video.currentTime = 0;
      this.video.muted = false;
      this.video.play().catch(() => {});
    }
  }

  close() {
    if (!this.panel) return;
    this.panel.hidden = true;
    this.classList.remove('is-open');
    if (this.video) {
      this.video.pause();
      this.video.currentTime = 0;
    }
    this.miniVideo?.play().catch(() => {});
  }
}

if (!customElements.get('product-video-float')) {
  customElements.define('product-video-float', ProductVideoFloat);
}
